import React from 'react';

import { Dialog } from '@mui/material';

import { STOItem } from 'commons/types';

import S from './RemoveSTOReceiveItemDialog.styles';

export interface IRemoveSTOReceiveItemDialogProps {
  onClose: () => void;
  onConfirm: () => void;
  openModal: boolean;
}

export const RemoveSTOReceiveItemDialog: React.FC<
  IRemoveSTOReceiveItemDialogProps
> = ({ onClose, onConfirm, openModal }) => {
  return (
    <Dialog onClose={onClose} open={openModal}>
      <S.TitleWrapper>
        <S.Title>REMOVE SKU</S.Title>
      </S.TitleWrapper>

      <S.Text>Are you sure to remove assigned items from your list?</S.Text>

      {/* Footer */}
      <S.FooterWrapper>
        <S.CancelButton onClick={onClose}>NO</S.CancelButton>
        <S.OKButton onClick={() => onConfirm()}>YES</S.OKButton>
      </S.FooterWrapper>
    </Dialog>
  );
};

export default RemoveSTOReceiveItemDialog;
